import { APICurrentUser } from '@ardoq/api-types';
import { permissionsOperations } from '@ardoq/access-control';
import { userOperations } from '@ardoq/core';
import { I18nLocale, t } from '@ardoq/i18n';
import { isTourStartable } from '@ardoq/product-tours';
import { startTour } from '@ardoq/product-tours-host';
import { dispatchAction } from '@ardoq/rxbeach';
import { Text } from '@ardoq/typography';
import { isPresentationMode } from 'env';
import {
  EphemeralCornerNotificationContent,
  EphemeralNotificationRelevanceContext,
} from '../types';

export const getDiscoverExperienceTourPromptContent = (
  i18nLocale: I18nLocale
): EphemeralCornerNotificationContent => ({
  position: 'bottom-left',
  cards: [
    {
      header: t(
        i18nLocale,
        'ephemeralNotification:discoverExperienceTour.header',
        "See what's new in Ardoq Discover"
      ),
      content: null,
      bodyText: (
        <Text variant="text2">
          {t(
            i18nLocale,
            'ephemeralNotification:discoverExperienceTour.bodyText',
            'This tour covers search, your data, and the assets shared with you.'
          )}
        </Text>
      ),
    },
  ],
  endButtonLabel: t(
    i18nLocale,
    'ephemeralNotification:discoverExperienceTour.startButton',
    'Show me around'
  ),
  showSkipButton: true,
  skipButtonLabel: t(
    i18nLocale,
    'ephemeralNotification:discoverExperienceTour.dismissButton',
    'Not now'
  ),
  onActionButtonClick: () => dispatchAction(startTour('discover-experience')),
});

export const isDiscoverExperienceTourRelevantForCurrentUser = (
  currentUser: APICurrentUser,
  {
    featureContext,
    toursWithSatisfiedDataGates,
  }: EphemeralNotificationRelevanceContext
): boolean =>
  !isPresentationMode() &&
  userOperations.hasOrgContributorRole(currentUser) &&
  isTourStartable('discover-experience', {
    featureContext,
    hasWriteAccess: permissionsOperations.isOrgWriter(currentUser),
    hostApp: 'ardoq-front',
    toursWithSatisfiedDataGates,
  });
